export function MultipleChoiceClassificationIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='1' y='0.5' width='15' height='15' rx='3.5' fill='currentColor' />
      <path
        d='M12.7064 4.79279C12.8939 4.98031 12.9992 5.23462 12.9992 5.49979C12.9992 5.76495 12.8939 6.01926 12.7064 6.20679L7.70643 11.2068C7.5189 11.3943 7.26459 11.4996 6.99943 11.4996C6.73427 11.4996 6.47996 11.3943 6.29243 11.2068L4.29243 9.20679C4.11027 9.01818 4.00948 8.76558 4.01176 8.50339C4.01403 8.24119 4.1192 7.99038 4.30461 7.80497C4.49002 7.61956 4.74083 7.51439 5.00303 7.51211C5.26523 7.50983 5.51783 7.61063 5.70643 7.79279L6.99943 9.08579L11.2924 4.79279C11.48 4.60532 11.7343 4.5 11.9994 4.5C12.2646 4.5 12.5189 4.60532 12.7064 4.79279Z'
        fill='white'
      />
      <rect x='1' y='0.5' width='15' height='15' rx='3.5' stroke='currentColor' />
    </svg>
  )
}
